// utils
import { getNestedValue } from "@swiggy-private/js-utils";
import { isValidNumber } from "@swiggy-private/core-ui";
import { isMROFlow } from "@cart-client/helpers/MROFoodCart";
// types
import { ReviewedCart } from "@cart-client/interfaces/Cart";
import { CroutonIds, SwiggySixesCroutonAPIInfo } from "@swiggy-private/cart-types";

export interface IPLSwiggySixesCartData {
    iplData?: SwiggySixesCroutonAPIInfo;
    // Absolute epoch seconds for the IPL offer expiry (from crouton list or legacy cart field).
    endTimestampInSec?: number;
}

/**
 * Resolves IPL Swiggy Sixes crouton info from cart response.
 * Checks both the crouton list entry (MRO) and iplSwiggySixesCroutonInfo, returning the
 * display data and a single end-timestamp (preferring the list entry in MRO).
 */
export const getIPLSwiggySixesDataFromCart = (cartResponse: ReviewedCart | null): IPLSwiggySixesCartData => {
    const iplData: SwiggySixesCroutonAPIInfo | undefined = getNestedValue(
        cartResponse,
        "data.iplSwiggySixesCroutonInfo",
    );
    const iplFromCroutonList = cartResponse?.data?.croutonList?.find(
        (crouton) => crouton.type === CroutonIds.IPL_SWIGGY_SIXES,
    );

    // In MRO the offer expiry is on the list entry as an absolute epoch (seconds).
    // Fall back to iplSwiggySixesCroutonInfo.offerExpiresInSec when the list entry is absent.
    const rawEndTimestamp = isMROFlow()
        ? iplFromCroutonList?.data?.endTimestamp ?? iplData?.offerExpiresInSec
        : iplData?.offerExpiresInSec;

    return {
        iplData,
        endTimestampInSec: isValidNumber(rawEndTimestamp) ? Number(rawEndTimestamp) : undefined,
    };
};
